/* eslint-disable no-console */
import { mapGetters } from "vuex";
import {
    default as expData,
    cookieName,
    generateCookie,
    readCookieString,
    isValidChannel
} from "@/common/experiments";
import { getCurrentSubdomain } from "@/common/functions";
import LayoutStatic from "@/layouts/LayoutStatic/LayoutStatic.vue";

export default {
    components: {
        LayoutStatic
    },
    data() {
        return {
            redirectURL: "",
            channels: expData.channels,
            subdomain: getCurrentSubdomain(),
            layout: LayoutStatic
        };
    },
    computed: {
        ...mapGetters({
            channel: "getExperimentChannel",
            date: "getExperimentDate"
        }),
        preparedLink() {
            if (this.redirectURL) {
                return `${window.location.origin}/abexp/${this.channel}?redirect=${this.redirectURL}`;
            }

            return null;
        }
    },
    methods: {
        onChannelButtonClick(channel) {
            this.updateChannel(channel);

            if (this.redirectURL) {
                window.location.assign(this.redirectURL);
            } else {
                window.location.assign("/");
            }
        },
        updateChannel(channel) {
            const cookieString = generateCookie(channel);
            this.$cookies.set(cookieName, cookieString, -1);

            const cookieData = readCookieString(cookieString);
            this.$store.commit("loadExperiments", cookieData);

            if (this.$ga) {
                this.$ga.set("dimension2", `v_${cookieData.channel}`);
            }
        }
    },
    created() {
        const params = this.$route.params;
        if (params.channel) {
            const overrideChannel = params.channel;
            if (isValidChannel(overrideChannel)) {
                this.updateChannel(overrideChannel);

                if (this.$route.query.redirect) {
                    window.location.assign(this.$route.query.redirect);
                } else {
                    console.debug(
                        `Channel ${overrideChannel} is not a vaid channel. Redirecting to experiment index page`
                    );
                    this.$router.push({
                        path: "/abexp"
                    });
                }
            }
        }
        this.$emit("update-layout", this.layout);
    },
    metaInfo: {
        title: "Yourdictionary A/B Experiment Control",
        meta: [
            {
                name: "robots",
                content: "noindex"
            }
        ]
    }
};



// WEBPACK FOOTER //
// ./src/pages/ExperimentOverride/ExperimentOverride.js